import { createContext } from 'react';

const ShipmentContext = createContext();
const ShipmentContextProvider = ShipmentContext.Provider;

export { ShipmentContext, ShipmentContextProvider };
